import { ChatFixture, tokenize } from './types';

/**
 * Journey 4 — legal-draft.
 *
 * Streams a demand-letter draft with an attorney-review banner and a PDF
 * download event at the end.
 */

const letter = `LAW OFFICES OF FERNANDO HIDALGO, INC.
1390 Market Street, Suite 200
San Francisco, CA 94102

ATTORNEY REVIEW REQUIRED — DO NOT SEND AS-IS

Via Certified Mail
[Recipient]
[Address]

Re: Demand for Reinstatement and Damages — Our Client, [Client Name]

Dear [Recipient]:

This firm represents [Client Name] in connection with [his/her] termination on [Date], which we believe constitutes wrongful termination in violation of public policy under Tameny v. Atlantic Richfield Co., 27 Cal. 3d 167 (1980). Our client engaged in protected activity — specifically, filing a workers compensation claim on [Claim Date] — and was terminated within [N] days thereafter. The temporal proximity alone establishes a prima facie case of retaliation under McDonnell Douglas.

We demand: (1) reinstatement to [his/her] prior position with full seniority and benefits; (2) back pay from the date of termination through reinstatement; (3) compensatory damages in the amount of $[X] for emotional distress; and (4) attorney's fees under Labor Code § 218.5 and § 1194.

Unless we receive a written response within fourteen (14) days, we will proceed with a civil action in Alameda County Superior Court.

Sincerely,

Fernando Hidalgo, Esq.
State Bar No. [XXXXXX]`;

export const legalDraftFixture: ChatFixture = {
  id: 'legal-draft',
  userQuery:
    'Draft a demand letter for our client — wrongful termination after a workers comp claim.',
  steps: ['thinking', 'outline', 'drafting', 'review-banner', 'pdf-ready'],
  chunks: [
    { delta: '', delayMs: 200, event: 'thinking', data: { label: 'Outlining letter...' } },
    {
      delta: '',
      delayMs: 140,
      event: 'attorney_review',
      data: { message: 'This draft requires attorney review before sending.' },
    },
    ...tokenize(letter, 35),
    {
      delta: '',
      delayMs: 220,
      event: 'pdf_ready',
      data: {
        title: 'Demand Letter — Wrongful Termination (Draft)',
        // No `url`: this is scripted demo data, and the path that used to sit
        // here pointed at a file that has never existed. Nothing renders it
        // today (MoonshotVoiceChat treats pdf_ready as a HUD event), so it
        // was harmless — but the day something DOES render it, the SPA
        // fallback would hand a viewer 28KB of HTML named as a PDF, with no
        // 404 anywhere. Add a real file under public/moonshot/pdf/ and the
        // url with it; scripts/check-static-asset-links.mjs refuses the
        // dangling shape.
        pageCount: 2,
        attorneyReviewRequired: true,
      },
    },
  ],
};

export default legalDraftFixture;
